<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  name: 'CompanionWidgetButton',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle() {
      if (!window.$cloudchat?.toggle) {
        // SDK not injected yet — ask the root widget to inject and open. The
        // open state is optimistic; the widget opens once the SDK is ready.
        this.$emitter.emit(BUS_EVENTS.CLOUDCHAT_SUPPORT_ACTIVATE);
        this.isOpen = true;
        return;
      }
      window.$cloudchat.toggle();
      // SDK does not dispatch a window event for open/close. Sync after the
      // next tick so the SDK has flipped its internal $cloudchat.isOpen flag
      // (see app/javascript/packs/sdk.js).
      this.$nextTick(() => {
        this.isOpen = !!window.$cloudchat?.isOpen;
      });
    },
  },
};
</script>

<template>
  <button
    v-tooltip.right="{
      content: $t('SIDEBAR.COMPANION_WIDGET'),
      classes: 'nav-rail-tooltip',
      boundariesElement: 'window',
    }"
    class="text-slate-700 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-gray-gray-2 dark:hover:bg-dark-dark-4 dark:hover:text-basic-primaryText hover:text-basic-primaryText relative"
    :class="{
      'bg-orange-light-4 dark:bg-orange-dark-4 text-basic-secondary hover:bg-orange-light-4 dark:hover:bg-orange-dark-4':
        isOpen,
    }"
    @click="toggle"
  >
    <fluent-icon-v2 icon="ia" :class="{ 'text-basic-secondary': isOpen }" />
    <span class="sr-only">{{ $t('SIDEBAR.COMPANION_WIDGET') }}</span>
  </button>
</template>
